import { createActions } from 'redux-actions';
import { create } from '../../services';

const {
  walkthroughCreateRequest,
  walkthroughCreateSuccess,
  walkthroughCreateFailure,
} = createActions({
  WALKTHROUGH_CREATE_SUCCESS: json => json,
}, 'WALKTHROUGH_CREATE_REQUEST', 'WALKTHROUGH_CREATE_FAILURE');

export function walkthroughCreate(walkthroughData) {
  return (dispatch) => {
    dispatch(walkthroughCreateRequest());
    return create('walkthrough', walkthroughData)
      .then(({ json }) => dispatch(walkthroughCreateSuccess(json)))
      .catch(error => dispatch(walkthroughCreateFailure(error)));
  };
}



// WEBPACK FOOTER //
// ./client/app/shared/actionCreators/walkthroughs.js